import { useContext, useEffect, useState } from "react";
import "./ModalidadeSelectionStep.styles.scss";
import { CartContext } from "../../contexts/CartContext";
import { GlobalContext } from "../../contexts/GlobalContext";
import { ProductsContext } from "../../contexts/ProductsContext";
import BtnBase from "../Buttons/BtnBase/BtnBase";

const ModalidadeSelectionStep = ({ nextStep }) => {
  const {
    modalidadesDisponiveis,
    selectedModalidades,
    setModalidadesForItem,
    fetchModalidades,
    confirmarModalidades,
  } = useContext(CartContext);
  const { carrinho } = useContext(GlobalContext);
  const { selectedSubproduct, setSelectedSubproduct, setSelectedProduct } = useContext(ProductsContext);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchModalidades();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const bag = carrinho?.find((b) => b.cartItems?.some((ci) => ci.itemTOTVSId === selectedSubproduct?.id));
  const studentId = bag?.studentId;
  const itemTOTVSId = selectedSubproduct?.id;
  const key = `${studentId}:${itemTOTVSId}`;
  const selecionadas = selectedModalidades[key] ?? [];
  const min = selectedSubproduct?.min_modalidades ?? 1;
  const max = selectedSubproduct?.max_modalidades ?? 1;

  if (!studentId) {
    return (
      <div className="mt-5 flex flex-col justify-center items-center gap-4">
        <p className="text-center text-grey-dark">Preparando seleção de modalidades...</p>
      </div>
    );
  }

  function handleToggle(id) {
    const jaTemModalidade = selecionadas.includes(id);
    const novas = jaTemModalidade
      ? selecionadas.filter((m) => m !== id)
      : [...selecionadas, id];
    setModalidadesForItem(studentId, itemTOTVSId, novas);
  }

  async function handleConfirmar() {
    if (selecionadas.length < min || selecionadas.length > max) {
      setError(
        `Selecione ${min === max ? min : `de ${min} a ${max}`} modalidade(s) antes de continuar.`
      );
      return;
    }
    setSaving(true);
    const ok = await confirmarModalidades();
    setSaving(false);
    if (ok) {
      setSelectedSubproduct();
      setSelectedProduct();
      nextStep();
    } else {
      setError("Erro ao salvar modalidades. Tente novamente.");
    }
  }

  const isCountOk = selecionadas.length >= min && selecionadas.length <= max;

  return (
    <div className="mt-5 flex flex-col justify-center gap-4">
      <h2 className="py-4 text-green-base font-semibold text-center text-base sm:text-2xl">
        Selecione{" "}
        {min === max
          ? `${min} modalidade${min > 1 ? "s" : ""}`
          : `de ${min} a ${max} modalidades`}
      </h2>
      <p className="modalidade-step-subtitle text-center text-sm">
        {selecionadas.length} selecionada{selecionadas.length !== 1 ? "s" : ""}{" "}
        <span className={isCountOk ? "modalidade-count-ok" : "modalidade-count-error"}>
          ({min === max ? `necessário: ${min}` : `mínimo: ${min}, máximo: ${max}`})
        </span>
      </p>

      <div className="modalidade-step-grid">
        {modalidadesDisponiveis.length === 0 && (
          <p className="text-center text-grey-dark">Carregando modalidades...</p>
        )}
        {modalidadesDisponiveis.map((mod) => {
          const checked = selecionadas.includes(mod.id);
          return (
            <label
              key={mod.id}
              className={`modalidade-step-option${checked ? " selected" : ""}`}
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() => handleToggle(mod.id)}
              />
              <span>{mod.nome}</span>
            </label>
          );
        })}
      </div>

      {error && <p className="modalidade-step-error text-center text-sm">{error}</p>}

      <div className="flex justify-center mt-4">
        <BtnBase
          OnClick={handleConfirmar}
          Disabled={saving}
          BtnTxt={saving ? "Salvando..." : "Confirmar e Continuar"}
          BtnClass={saving ? "btn-disabled-lg" : "btn-yellow-lg"}
        />
      </div>
    </div>
  );
};

export default ModalidadeSelectionStep;
